import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import './assets/custom.scss'
import VueDragResize from 'vue-drag-resize'
import mixin from './components/Mixin.vue'
import vSelect from 'vue-select'
import Vuex from 'vuex'
// import firebase from 'firebase/app'
import excel from 'vue-excel-export'
// import 'firebase/firestore'
import VueApexCharts from 'vue-apexcharts'

// var firebaseConfig = {
//   apiKey: "AIzaSyAdg1YeNnALJjbV6_of8yFSC3h5GYJf-rQ",
//   authDomain: "joe-chen-test-7fafb.firebaseapp.com",
//   projectId: "joe-chen-test-7fafb",
//   storageBucket: "joe-chen-test-7fafb.appspot.com",
//   messagingSenderId: "960991485477",
//   appId: "1:960991485477:web:0cadaa6b5772198ddd69cc",
//   measurementId: "G-RELRYC9Y53"
// };

// export const db = firebase.initializeApp(firebaseConfig).firestore()

Vue.use(excel)
Vue.component('apexchart', VueApexCharts)
Vue.component('v-select', vSelect)
Vue.mixin(mixin)
Vue.component('vue-drag-resize', VueDragResize)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuex)
Vue.use(VueApexCharts)

Vue.prototype.$axios = axios;
axios.defaults.baseURL="/api"
axios.defaults.headers.post['Content-Type'] = 'application/json';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
